module.exports = __webpack_public_path__ + "3cc4e2f799bb0ca94461c82df3808d6a.png";